import React from 'react';
import SolicitarEdital from 'components/atoms/solicitar_edital';

const SolicitacaoEdital: React.FC = () => {
  return (
    <div className="page-container">
      <div className="container p-4">
        <div className="row mb-3">
          <div className="col-md-3 col-12 mb-3" />
          <div className="col-md-11 col-12">
            <div className="card">
              <div className="card-body">
                <h4>Solicitar Edital</h4>
                <SolicitarEdital />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export { SolicitacaoEdital };
